import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match!");
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/reset-password`, {
        token,
        newPassword,
      });

      setSuccess(response.data.message);
      setError("");
      setTimeout(() => navigate("/clientlogin"), 2000); // Redirect to login
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong!");
    }
  };

  return (
    <div className="flex flex-col md:flex-row items-start justify-center min-h-screen bg-gray-100 p-8 bg-cover bg-center">
      <div>
        <div className="flex flex-col items-center mb-10 md:mb-0 md:mr-10">
          <h1 className="text-4xl font-bold text-center bg-white px-4 py-2 rounded shadow">
            <span className="bg-black text-gray-100 px-2 rounded">OneLegal</span> Project
          </h1>
          <h2 className="text-center text-3xl font-bold mb-4">Reset Password</h2>
        </div>

        <div className="max-w-sm bg-white p-6 rounded-lg shadow-md mx-auto md:mx-0">
          {error && (
            <div className="bg-red-100 text-red-800 text-sm px-4 py-2 rounded mb-4 border border-red-300">
              {error}
            </div>
          )}
          {success && (
            <div className="bg-green-100 text-green-800 text-sm px-4 py-2 rounded mb-4 border border-green-300">
              {success}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <label className="block mb-2 font-semibold">New Password</label>
            <input
              type="password"
              placeholder="Enter new password"
              className="w-full px-3 py-2 border rounded mb-4"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />

            <label className="block mb-2 font-semibold">Confirm Password</label>
            <input
              type="password"
              placeholder="Confirm new password"
              className="w-full px-3 py-2 border rounded mb-4"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />

            <button
              type="submit"
              className="w-full bg-black text-white py-2 rounded hover:bg-yellow-500 transition"
            >
              Reset Password
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
